module.exports = __webpack_public_path__ + "img/43.04e8d741.jpg";